import { render, staticRenderFns } from "./follow-form-edit.vue?vue&type=template&id=2c2c7e22&"
import script from "./follow-form-edit.vue?vue&type=script&lang=js&"
export * from "./follow-form-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports